import { Row, Container, Col, Card, Button } from 'react-bootstrap';
import Link from 'next/link';
import { BackgroundImage } from '../../media/utils/imgix';

export default function HeaderImage() {
  return (
    <Row>
      <Container>
        <BackgroundImage imgKey="/trips/trip_2Q2JD87PNDWXN5DT/images/header/9cc32f17-6f22-4637-9105-ca8c8d651083.jpg">
          <Col className="p-5 mt-0 mb-0 h-50">
            <Col className="pt-5 pb-5" sm={12} md={6} lg={6}>
              <Card className="mb-5 mt-5">
                <Card.Body>
                  <h2 className="display-4">Become a Host</h2>
                  <Card.Text>
                    Sell your trips and adventures with Skyhook
                  </Card.Text>
                  <Link href="/hosts/join/apply" legacyBehavior>
                    <Button size="lg" variant="primary">
                      Apply to Host
                    </Button>
                  </Link>
                  <Link href="/help/contact" passHref legacyBehavior>
                    <Button variant="link" className="text-dark" size="lg">
                      Contact Us
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Col>
        </BackgroundImage>
      </Container>
    </Row>
  );
}
